<template>
  <div>
  <base-modal
    :customShowDialog="showListQueriesModal"
    dialog-max-width="70vw"
    :title="$t('modal.openSearchStrategy.title')"
    :hasMainBtn="false"
    @close="handleClose"
    @confirmed="$emit('confirm')"
  >
   <div slot="body" style="font-size: 16px">
     <display-files
       :queries="queries"
       :hasActionColumn="true"
       @confirm="(id) => $emit('confirm', id)"
       @queryToDeleteId="handleDeleteClick"
     ></display-files>
   </div>
  </base-modal>
  <confirm-delete-modal
    :show-modal="showDeleteModal"
    :query="queryToDelete"
    @close="handleCloseDeleteModal"
    @completed="handledDeleteCompleted"
    @error="handleDeleteError"
  ></confirm-delete-modal>
  </div>
</template>

<script>
import Sugar from 'sugar'
import BaseModal from '../modals/BaseModal'
import ConfirmDeleteModal from '../modals/ConfirmDeleteModal'
import DisplayFiles from '../parts/DisplayFiles'

export default {
  name: 'open-search-strategy-modal',
  components: {
    BaseModal,
    ConfirmDeleteModal,
    DisplayFiles
  },
  props: ['queries', 'defaultSearchName'],
  data () {
    return {
      queryToDelete: null,
      showDeleteModal: false,
      currentSortField: 'name',
      currentSortAscending: true,
      sortedQueries: [...this.queries]
    }
  },
  watch: {
    queries: function (val, oldVal) {
      this.prepareData()
      this.sortQueries()
    }
  },
  created () {
    Sugar.extend()
  },
  mounted () {
    this.prepareData()
  },
  computed: {
    showListQueriesModal: { get () { return this.$store.state.modalState.showListQueriesModal } }
  },
  methods: {
    prepareData () {
      this.sortedQueries = [...this.queries]
      this.sortedQueries.map(x => {
        x.sugarUpdatedAt = Sugar.Date.create(x.updatedAt)
      })
    },
    formatDate (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.format(q.sugarUpdatedAt, '%d %h %y - %X')
      } else {
        return ''
      }
    },
    formatDateRelative (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.relative(q.sugarUpdatedAt)
      } else {
        return ''
      }
    },
    formulateIcon (targetField) {
      if (targetField === this.currentSortField) {
        return this.currentSortAscending ? 'arrow_drop_down' : 'arrow_drop_up'
      } else {
        return ''
      }
    },
    handleDeleteClick (q) {
      this.queryToDelete = q
      this.showDeleteModal = true
    },
    handleCloseDeleteModal () {
      this.queryToDelete = null
      this.showDeleteModal = false
    },
    handledDeleteCompleted () {
      this.queryToDelete = null
      this.$emit('deleteCompleted')
    },
    handleDeleteError (error) {
      this.$store.commit('setSnackbarText', error)
    },
    formulateSearchName: function (q) {
      return q && q.defaultSearchName
        ? q.defaultSearchName
        : this.defaultSearchName
    },
    sortQueries () {
      if (typeof this.queries === 'undefined' || this.queries === null || this.queries.length <= 1) {
        return
      }
      const f = this.currentSortField
      this.sortedQueries.sort((a, b) => {
        if (f === 'name') {
          return this.currentSortAscending
            ? a[f].localeCompare(b[f])
            : b[f].localeCompare(a[f])
        } else if (f === 'search') {
          return this.currentSortAscending
            ? this.formulateSearchName(a).localeCompare(this.formulateSearchName(b))
            : this.formulateSearchName(b).localeCompare(this.formulateSearchName(a))
        } else {
          if (a.sugarUpdatedAt.isBefore(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? -1 : 1
          }
          if (a.sugarUpdatedAt.isAfter(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? 1 : -1
          }
          return 0
        }
      })
    },
    handleSortClick (targetField) {
      if (targetField === this.currentSortField) {
        this.currentSortAscending = !this.currentSortAscending
      } else {
        this.currentSortField = targetField
        this.currentSortAscending = true
      }
      this.sortQueries()
    },
    handleClose () {
      this.$store.commit('setShowListQueriesModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mainMenu/OpenSearchStrategyModal.vue